"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./modal/modal-backdrop.component'));
__export(require('./modal/modal-options.class'));
__export(require('./modal/modal.component'));
var modal_module_1 = require('./modal/modal.module');
exports.ModalModule = modal_module_1.ModalModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/modal.js
// module id = 664
// module chunks = 0